import React from 'react';
import {
    Typography,
    Box,
    Switch,
    FormControlLabel,
    Grid,
    TextField,
    MenuItem,
    Autocomplete
} from '@mui/material';

const STATUSES = [
    'All Statuses',
    'executed', 'approved', 'on hold', 'learning', 'initiated', 'shared',
    'ordered', 'processing', 'awaiting approval', 'needs action', 'confirmed', 'logged'
];

const REGIONS = [
    'All Regions',
    'North America',
    'Europe',
    'Asia',
    'Africa',
    'South America',
    'Australia',
    'HQ'
];

const AGENT_OPTIONS = [
    // 🇺🇸 United States (Grouped under North America)
    { label: 'Los Angeles Agent', group: 'North America' },
    { label: 'Pasadena Agent', group: 'North America' },
    { label: 'Oakland Agent', group: 'North America' },
    { label: 'San Diego Agent', group: 'North America' },
    { label: 'San Francisco Agent', group: 'North America' },
    { label: 'Brooklyn Agent', group: 'North America' },
    { label: 'Bronx Agent', group: 'North America' },
    { label: 'Queens Agent', group: 'North America' },
    { label: 'New York Agent', group: 'North America' },
    { label: 'Detroit Agent', group: 'North America' },
    { label: 'Chicago Agent', group: 'North America' },
    { label: 'Miami Agent', group: 'North America' },
    { label: 'Austin Agent', group: 'North America' },
    { label: 'Dallas Agent', group: 'North America' },
    { label: 'Phoenix Agent', group: 'North America' },
    { label: 'Seattle Agent', group: 'North America' },
    { label: 'Houston Agent', group: 'North America' },
    { label: 'Tampa Agent', group: 'North America' },
    { label: 'Atlanta Agent', group: 'North America' },
    { label: 'Toronto Agent', group: 'North America' }, // Canada

    // 🌍 International
    { label: 'London Agent', group: 'Europe' },
    { label: 'Dublin Agent', group: 'Europe' },
    { label: 'Tokyo Agent', group: 'Asia' },
    { label: 'Mumbai Agent', group: 'Asia' },
    { label: 'Melbourne Agent', group: 'Australia' },
    { label: 'Manila Agent', group: 'Asia' },
    { label: 'Rio de Janeiro Agent', group: 'South America' },
    { label: 'Cape Town Agent', group: 'Africa' },
    { label: 'Nairobi Agent', group: 'Africa' },

    // 🧠 Special & global
    { label: 'Global Agent', group: 'HQ' },
    { label: 'All Agents', group: 'System' }
];

const WhookStreamHeader = ({ realTimeMode, onToggle, filters = {}, onFilterChange = () => {} }) => {
    const currentAgent = filters.agent || 'All Agents';
    const currentStatus = filters.status || 'All Statuses';
    const currentRegion = filters.region || 'All Regions';

    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h4" gutterBottom sx={{ color: '#12c099', fontWeight: 600 }}>
                Whook AI Stream
            </Typography>

            <Typography variant="body1" sx={{ color: '#ccc', mb: 2 }}>
                🧠 Real-time decisions and intelligence logs generated by <strong>Whook AI®</strong>
            </Typography>

            <FormControlLabel
                control={
                    <Switch
                        checked={realTimeMode}
                        onChange={(e) => onToggle(e.target.checked)}
                        color="primary"
                    />
                }
                label="Real-Time Mode"
                sx={{
                    '& .MuiFormControlLabel-label': { color: '#fff' }
                }}
            />

            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={4}>
                    <Autocomplete
                        disablePortal
                        options={AGENT_OPTIONS}
                        groupBy={(option) => option.group}
                        value={AGENT_OPTIONS.find(opt => opt.label === currentAgent) || null}
                        onChange={(e, newValue) => {
                            onFilterChange('agent', newValue?.label || 'All Agents');
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Agent"
                                size="small"
                                sx={{ backgroundColor: '#1a1a1a' }}
                                InputLabelProps={{ sx: { color: '#ccc' } }}
                                InputProps={{ ...params.InputProps, sx: { color: '#fff' } }}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        select
                        size="small"
                        label="Status"
                        value={currentStatus}
                        onChange={(e) => onFilterChange('status', e.target.value)}
                        fullWidth
                        sx={{ backgroundColor: '#1a1a1a' }}
                        InputLabelProps={{ sx: { color: '#ccc' } }}
                        InputProps={{ sx: { color: '#fff' } }}
                    >
                        {STATUSES.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        select
                        size="small"
                        label="Region"
                        value={currentRegion}
                        onChange={(e) => onFilterChange('region', e.target.value)}
                        fullWidth
                        sx={{ backgroundColor: '#1a1a1a' }}
                        InputLabelProps={{ sx: { color: '#ccc' } }}
                        InputProps={{ sx: { color: '#fff' } }}
                    >
                        {REGIONS.map((region) => (
                            <MenuItem key={region} value={region}>
                                {region}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid>
        </Box>
    );
};

export default WhookStreamHeader;
